import React from 'react'

import LogoConstructora from './../../UI/Logos/logo-constructora.svg'

interface Props{
    isLoading: boolean,
    gettingProjectInfo: boolean,
    errorGettingProjectInfo: boolean,
    downloadingImagesInfo: boolean,
    errorDownloadingImages: boolean
}

interface State{
    currentStrokeColor: string
}

class LoadingScreen extends React.Component<Props, State>{
    constructor(props: Props){
        super(props);
        this.state = {
            currentStrokeColor: "#FCC200"
        }
    }

    componentDidMount(){
        var strokeColors = ["#FCC200","#D4102A","#85BB24","#00993C"]
        if(this.props.isLoading){
            setInterval(() => {
                this.setState({
                    currentStrokeColor: strokeColors[Math.floor(Math.random() * 4)]
                })
            }, 1000)
        }
    }

    render(){
        return(
            <div className={this.props.isLoading ? "loading-div fade-in":"loading-div fade-out"}>
                <img src={LogoConstructora} className='logo-constructora'/>
                <svg className="loader-circle" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                    <circle className= 'internal-circle' cx="75" cy="75" r="70"></circle>
                </svg>
                <svg className="loader-circle-over" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg" style={{stroke: this.state.currentStrokeColor}}>
                    <circle className= 'internal-circle-over' cx="75" cy="75" r="70" style={{stroke: this.state.currentStrokeColor}}></circle>
                </svg>
                <div className='loading-info-container'>
                    <div className={this.props.gettingProjectInfo ? "fade-in":"fade-out"}>{this.props.errorGettingProjectInfo ? "Error obteniendo información":"Obteniendo información"}</div>
                    <div className={this.props.downloadingImagesInfo ? "fade-in":"fade-out"}>{this.props.errorDownloadingImages ? "Error descargando Imágenes":"Descargando Imágenes"}</div>
                </div>
            </div>
        )
    }
}

export default LoadingScreen